import React, { useEffect } from "react";
import "./FlyingImage.css";

interface FlyingImageProps {
  imgSrc: string;
  itemOffsets: { top: number; left: number };
  onAnimationEnd: () => void;
}

export const FlyingImage: React.FC<FlyingImageProps> = ({
  imgSrc,
  itemOffsets,
  onAnimationEnd,
}) => {
  const imgStyle: React.CSSProperties = {
    top: `65px`,
    left: `8%`,
    width: "250px",
    height: "250px",
    position: "absolute",
    zIndex: 101,
  };

  useEffect(() => {
    const cart = document.querySelector(".b-cart");
    if (!cart) return;

    const cartOffset = cart.getBoundingClientRect();
    const flyingImg = document.querySelector(
      ".b-flying-img"
    ) as HTMLImageElement;

    if (flyingImg) {
      setTimeout(() => {
        if (window.innerWidth <= 768) {
          flyingImg.style.top = `${cartOffset.top - 0}px`;
          flyingImg.style.left = `${cartOffset.left + 0}px`;
        } else {
          flyingImg.style.top = `${cartOffset.top - 0}px`;
          flyingImg.style.left = `${cartOffset.left + 0}px`;
        }

        flyingImg.style.width = "20px";
        flyingImg.style.height = "20px";
        flyingImg.style.zIndex = "105";
      }, 0);

      flyingImg.addEventListener("transitionend", onAnimationEnd);
      return () =>
        flyingImg.removeEventListener("transitionend", onAnimationEnd);
    }
  }, [itemOffsets, onAnimationEnd]);

  return (
    <div
      className="flying-img-container"
      style={{ position: "absolute", top: "0px" }}
    >
      <img
        className="b-flying-img"
        src={imgSrc}
        alt="Flying"
        style={imgStyle}
      />
    </div>
  );
};
